import { type TezosToolkit } from "@taquito/taquito";
import { useAsyncActionHandler, useSelectedNetwork } from "@umami/state";

type UseSubmitShieldProps = {
  toolkit: TezosToolkit;
  shieldedTx: string;
  amount: number;
};

export const useSubmitShield = ({ toolkit, shieldedTx, amount }: UseSubmitShieldProps) => {
  const { isLoading, handleAsyncAction } = useAsyncActionHandler();
  const network = useSelectedNetwork();
  const saplingContractAddress = network.saplingContractAddress ?? "";

  const submitShield = () =>
    handleAsyncAction(async () => {
      const saplingContract = await toolkit.contract.at(saplingContractAddress);

      const op = await saplingContract.methodsObject.default([shieldedTx]).send({ amount });
      await op.confirmation(1);

      return op.hash;
    });

  return {
    submitShield,
    isLoading,
  };
};
